import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import Breadcrumbs from '@components/Breadcrumbs/Breadcrumbs';
import Image from 'next/image';
import { siteUrl } from '@common/constant';

type propsBanner = {
  title: string;
  description?: any;
  childComponent?: ReactNode;
  backgroundImage?: string;
  altBackground?: string;
  itemBreadcrumbs?: { name: string; path: string }[];
};

const Banner = ({
  title,
  description,
  childComponent,
  backgroundImage,
  altBackground,
  itemBreadcrumbs,
}: propsBanner) => {
  const router = useRouter();

  return (
    <div className="banner">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            '@id': `${siteUrl}${router.pathname}/#breadcrumb`,
            itemListElement: itemBreadcrumbs?.map(({ name, path }, index) =>
              index < itemBreadcrumbs.length - 1
                ? {
                    '@type': 'ListItem',
                    position: index + 1,
                    name: name,
                    item: `${siteUrl}${path}`,
                  }
                : {
                    '@type': 'ListItem',
                    position: index + 1,
                    name: name,
                  },
            ),
          }),
        }}
      ></script>
      {title ? <h1 className="hide">{title}</h1> : null}
      <div className="container">
        {itemBreadcrumbs && <Breadcrumbs items={itemBreadcrumbs} />}
        <div
          className="banner__title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />

        <div
          className="banner__subtitle"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />

        {childComponent}
      </div>

      {backgroundImage && (
        <div className="banner__image-container">
          <Image
            src={backgroundImage}
            alt={altBackground || 'background image'}
            layout="fill"
            objectFit="cover"
            quality={100}
          />
        </div>
      )}
    </div>
  );
};

export default Banner;
